// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0660dec0","64":"b3b953c0","981":"f6226d2e"}[chunkId] + ".chunk.js";
};